import { render, staticRenderFns } from "./IdentifierSummary.vue?vue&type=template&id=44af5f08&scoped=true&"
import script from "./IdentifierSummary.vue?vue&type=script&lang=js&"
export * from "./IdentifierSummary.vue?vue&type=script&lang=js&"
import style0 from "./IdentifierSummary.vue?vue&type=style&index=0&id=44af5f08&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44af5f08",
  null
  
)

export default component.exports